import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningIcon from '@mui/icons-material/Warning';
import { NewConvergeButton } from '../../presentation';
import '../entity/claim/delete-contact-modal.scss';

interface UnmetSubjectivitiesDialogProps {
  open: boolean;
  onClose: () => void;
  subjectivities: string[];
}

export const UnmetSubjectivitiesDialog = ({
  open,
  onClose,
  subjectivities,
}: UnmetSubjectivitiesDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth={true}
      PaperProps={{
        sx: {
          width: '680px',
          minHeight: '250px',
        },
      }}
    >
      <DialogTitle
        sx={{
          padding: 4,
          paddingBottom: 0,
          marginLeft: '30px',
          marginBottom: 0,
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          paddingTop="10px"
          paddingRight="15px"
        >
          <Box sx={{ marginTop: 2 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '24px',
                fontWeight: 400,
                color: '#D32F2F',
              }}
            >
              <WarningIcon sx={{ marginRight: '5px', color: '#D32F2F' }} />
              Unmet subjectivities
            </Box>
          </Box>
          <IconButton
            edge="end"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ padding: 4, paddingTop: 0, marginLeft: '30px' }}>
        <Box sx={{ fontSize: '14px', fontWeight: 400 }}>
          The following subjectivities that must be satisfied or waived prior to
          policy issuance:
        </Box>
        <Stack>
          <div>
            <ul>
              {subjectivities.map((s) => (
                <li key={s} style={{ fontSize: '14px', fontWeight: 500 }}>
                  {s}
                </li>
              ))}
            </ul>
          </div>
        </Stack>
        <Stack
          sx={{
            flexDirection: 'row',
            justifyContent: 'flex-end',
            marginRight: '20px',

            marginTop: '20px',
          }}
        >
          <NewConvergeButton
            label="CLOSE"
            variant="outlined"
            onClick={onClose}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
